
import {
  getEnterprise,
  setEnterprise,
  setGoogleAuth,
  setBotGoogleAuth,
  searchTelegramGroup,
  sendTelegramMessage,
  changeAntGoogleAuth,
  getAntGoogleAuth
} from '@/api/universal'

import { AppModule } from '@/store/modules/app'
import { reqInterceptors } from '@/utils/interceptors'
import { operationMessage } from '@/utils/message'
import { checkNeedAudit } from '@/utils/permission'
import { exchangeRateRules, newSettingRules } from '@/utils/rules'
import { Form as ElForm, MessageBox } from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import sendMes from './components/sendMes.vue'
import setTime from './components/setTimezone.vue'
import LogoUploader from '@/components/LogoUploader/index.vue'
import boundGroup from './components/bound-group.vue'
import groupCalssify from './components/group-calssify.vue'
import forward from './components/forward.vue'
import orderList from './components/order-list.vue'
import HolidayConfig from './components/holidayConfig.vue'

@Component({
  name: 'test',
  components: {
    sendMes,
    setTime,
    LogoUploader,
    boundGroup,
    groupCalssify,
    orderList,
    forward,
    HolidayConfig
  }
})
export default class extends Vue {
  private activeName: any = '1'
  get language() {
    return AppModule.language
  }

  private changeActive(value) {
    console.log(value)
  }

  private form: any = {}
  private dialogVisible: boolean = false
  private dialogVisibles: boolean = false
  private dialogVisible1: boolean = false
  private dialogVisible2: boolean = false
  private showSiteName: boolean = false
  private showSiteLogo: boolean = false
  private showForwardApi: boolean = false
  private showForwardHash: boolean = false
  private tabName: string = '1'

  private setForm: any = {
    test_merchant_no: '',
    description: '',
    payout_notify_switch: false,
    disable_merchant_set_ip_whitelist: false,
    ant_payout_payment_switch: false,
    auto_refund: false,
    merchant_login_google_auth_switch: 0,
    merchant_backoffice_payout_switch: 1,
    payout_risk_duplicate_account_switch: 0,
    payout_risk_duplicate_account_window_hours: '',
    payout_risk_duplicate_account_max_count: '',
    payout_risk_duplicate_account_min_amount: '',
    notify_withdraw_switch: 0,
    notify_usdt_collect_switch: 0,
    holidays_settlement_time_switch: 0,
    thai_notify_switch: 0,
    safety_notify_switch: 0,
    inr_notify_switch: 0,
    account_rate_notify_switch: 0,
    php_notify_switch: 0,
    eur_notify_switch: 0,
    ngn_notify_switch: 0,
    rm_notify_switch: 0,
    gcash_notify_switch: 1,
    usd_cap_notify_switch: 1,
    ant_limit_notify_switch: 1,
    ant_register_notify_switch: 0,
    test_order_notify_switch: 0,
    telegram_account_switch: 0,
    photo_switch: 1,
    asyn_photo_switch: 0,
    bot_cars_switch: 0,
    api_error_switch: 0,
    api_sms_switch: 0,
    clave_notify_switch: 0,
    group_name: null,
    notify_withdraw_telegram_group_id: [],
    thai_notify_telegram_group: [],
    thai_notify_account_type: [],
    inr_notify_telegram_group: [],
    account_rate_notify_telegram_group: [],
    php_notify_telegram_group: [],
    eur_notify_telegram_group: [],
    ngn_notify_telegram_group: [],
    rm_notify_telegram_group: [],
    api_error_notify_telegram_group: [],
    api_sms_notify_telegram_group: [],
    gcash_notify_telegram_group: [],
    usd_cap_notify_telegram_group: [],
    ant_limit_notify_telegram_group: [],
    ant_register_telegram_group: [],
    telegram_group_id: [],
    safety_notify_telegram_group: [],
    telegram_robot_token: '',
    bot_cert_style: 0,
    telegram_devops_robot_token: '',
    telegram_robot_username: '',
    telegram_robot_firstname: '',
    telegram_devops_robot_username: '',
    telegram_devops_robot_firstname: '',
    site_name: '',
    site_logo: '',
    order_list: [],
    telegram_group: [],
    telegram_api_id: '',
    telegram_api_hash: '',
    telegram_account_username: '',
    telegram_account_name: '',
    rm_deposit_notify_switch: 0,
    rm_payout_notify_switch: 0,
    rm_deposit_notify_telegram_group: [],
    rm_payout_notify_telegram_group: [],
    rm_collect_notify_switch: 0,
    rm_collect_notify_telegram_group: [],
    fp_robot_token: '',
    fp_robot_username: '',
    fp_robot_firstname: '',
    fp_bot_switch: 0,
    fp_telegram_group: [],
    exchange_switch: 0,
    fp_chat_id: ''
  }

  private tgInfoObj: any = [
    {
      // 出金审查任务通知
      switch: 'notify_withdraw_switch',
      group: 'notify_withdraw_telegram_group_id'
    },
    {
      // USDT Telegram 通知开关
      switch: 'notify_usdt_collect_switch',
      group: 'telegram_group_id'
    },
    {
      // 安全通知开关按钮
      switch: 'safety_notify_switch',
      group: 'safety_notify_telegram_group'
    },
    {
      // thai 通知开关
      switch: 'thai_notify_switch',
      group: 'thai_notify_telegram_group'
    },
    {
      // 账户成功率骤降通知
      switch: 'account_rate_notify_switch',
      group: 'account_rate_notify_telegram_group'
    },
    {
      // INR 通知开关
      switch: 'inr_notify_switch',
      group: 'inr_notify_telegram_group'
    },
    {
      // PHP 通知开关
      switch: 'php_notify_switch',
      group: 'php_notify_telegram_group'
    },
    {
      // EUR 通知开关
      switch: 'eur_notify_switch',
      group: 'eur_notify_telegram_group'
    },
    {
      // NGN 通知开关
      switch: 'ngn_notify_switch',
      group: 'ngn_notify_telegram_group'
    },
    {
      // GCash 防盗刷通知开关
      switch: 'gcash_notify_switch',
      group: 'gcash_notify_telegram_group'
    },
    {
      // CAP 异常通知
      switch: 'usd_cap_notify_switch',
      group: 'usd_cap_notify_telegram_group'
    },
    {
      // 蚂蚁上分上限通知
      switch: 'ant_limit_notify_switch',
      group: 'ant_limit_notify_telegram_group',
      platform: 'ant'
    },
    {
      // 新增马来西亚通知开关 (RM通知开关)
      switch: 'rm_notify_switch',
      group: 'rm_notify_telegram_group'
    },
    {
      // API报错通知
      switch: 'api_error_switch',
      group: 'api_error_notify_telegram_group'
    },
    {
      // SMS 通知
      switch: 'api_sms_switch',
      group: 'api_sms_notify_telegram_group'
    },
    {
      // “蚂蚁注册通知”
      switch: 'ant_register_notify_switch',
      group: 'ant_register_telegram_group',
      platform: 'ant'
    },
    {
      // RM代收
      switch: 'rm_deposit_notify_switch',
      group: 'rm_deposit_notify_telegram_group'
    },
    {
      // RM代付
      switch: 'rm_payout_notify_switch',
      group: 'rm_payout_notify_telegram_group'
    },
    {
      // RM归集
      switch: 'rm_collect_notify_switch',
      group: 'rm_collect_notify_telegram_group'
    }
  ]

  private FpObj: any = [
    // 机器人群组和开关
    {
      switch: 'fp_bot_switch',
      group: 'fp_telegram_group'
    }
  ]

  private closeDrawer() {
    this.isDrawerVisible = false
    this.isDrawerVisible2 = false
    this.tabName = '1'
  }
  private geogleRules: any = {
    action: [
      { required: true, message: 'Please select action', trigger: 'blur' }
    ],
    google_code: [
      { required: true, message: 'Please input Google code', trigger: 'blur' }
    ]
  }

  // 基础设置表单
  private baseForm: any = {
    buy_usdt_rate: '0',
    sale_usdt_rate: '0',
    exchange_usdt_rate: '0',
    exchange_balance_freeze_hours: '0',
    collection_balance_freeze_hours: '0',
    kefu_link: '',
    register_switch: '',
    register_apply_switch: '',
    close_buy: 0,
    wallet_delete_switch: 0,
    whatsapp_switch: '0',
    telegram_switch: '0',
    ant_withdraw_fee: {
      fix_fee: 0,
      rate: 0
    },
    ant_erc20_withdraw_fee: {
      fix_fee: 0,
      rate: 0
    },
    buy_platform_usdt_rate: '',
    topup_freeze: 0,
    buy_platform_usdt_min_amount: '',
    merchant_deposit_settlment_rate: '',
    merchant_payout_settlment_rate: '',
    merchant_exchange_settlment_rate: '',
    in_maintain: [],
    exchange_in_maintain: [],
    ant_withdraw_max_order_count: '1',
    ant_withdraw_expire_min: '10',
    buy_freeze: '0',
    ant_wallet_type: {
      ant_erc20: 1,
      ant_trc20: 1,
      ant_inr: 1
    }
  }
  private baseDisabled: boolean = false
  private async baseSave() {
    try {
      this.baseDisabled = true
      let data: any = {
        ssl_switch: {
          ...this.baseForm
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.baseDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }
  private baseReset() {
    this.baseForm = {
      buy_usdt_rate: '0',
      sale_usdt_rate: '0',
      collection_balance_freeze_hours: '0',
      kefu_link: '',
      register_switch: '',
      register_apply_switch: '',
      close_buy: 0,
      wallet_delete_switch: 0,
      whatsapp_switch: '0',
      telegram_switch: '0',
      ant_withdraw_fee: {
        fix_fee: 0,
        rate: 0
      },
      ant_erc20_withdraw_fee: {
        fix_fee: 0,
        rate: 0
      },
      buy_platform_usdt_rate: '',
      topup_freeze: 0,
      wallet_reset_duration: 2,
      buy_platform_usdt_min_amount: '',
      merchant_deposit_settlment_rate: '',
      merchant_payout_settlment_rate: '',
      merchant_exchange_settlment_rate: '',
      in_maintain: [],
      exchange_in_maintain: [],
      ant_withdraw_max_order_count: '1',
      ant_withdraw_expire_min: '10',
      buy_freeze: '0',
      ant_wallet_type: {
        ant_erc20: 1,
        ant_trc20: 1,
        ant_inr: 1
      }
    }
  }

  private async setForwardApiId() {
    let data: any = {
      ssl_switch: {
        telegram_api_id: this.setForm.telegram_api_id
      }
    }
    await setEnterprise(data).then(() => {
      this.$message({
        message: 'Operation Successfully!',
        type: 'success'
      })
      this.showForwardApi = false
      this.getEnterprise()
    })
  }

  private async setForwardApiHash() {
    let data: any = {
      ssl_switch: {
        telegram_api_hash: this.setForm.telegram_api_hash
      }
    }
    await setEnterprise(data).then(() => {
      this.$message({
        message: 'Operation Successfully!',
        type: 'success'
      })
      this.showForwardHash = false
      this.getEnterprise()
    })
  }

  // 返佣设置表单
  private rebateForm: any = {
    sale_usdt_rebate_rate: '0',
    buy_usdt_rebate_rate: '0',
    sale_rebate_freeze_time: '0',
    buy_rebate_freeze_time: '0',
    exchange_usdt_rebate_rate: '0',
    exchange_rebate_freeze_time: '0'
    // usdt_rebate_freeze_time: '0'
  }
  private rebateDisabled: boolean = false
  private async rebateSave() {
    try {
      this.rebateDisabled = true
      let data: any = {
        ssl_switch: {
          ...this.rebateForm
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.rebateDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.rebateDisabled = false
      this.getEnterprise()
    }
  }
  private rebateReset() {
    this.rebateForm = {
      sale_usdt_rebate_rate: '0',
      buy_usdt_rebate_rate: '0',
      sale_rebate_freeze_time: '0',
      buy_rebate_freeze_time: '0',
      exchange_usdt_rebate_rate: '0',
      exchange_rebate_freeze_time: '0'
      // usdt_rebate_freeze_time: '0'
    }
  }

  // 推荐返佣表单
  private suggestForm: any = {
    yiji_rebate_rate: '0',
    erji_rebate_rate: '0',
    sanji_rebate_rate: '0',
    friend_rebate_freeze_time: '0'
  }
  private suggestDisabled: boolean = false
  private async suggestSave() {
    try {
      this.suggestDisabled = true
      let data: any = {
        ssl_switch: {
          ...this.suggestForm
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.suggestDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.suggestDisabled = false
      this.getEnterprise()
    }
  }
  private suggestReset() {
    this.suggestForm = {
      yiji_rebate_rate: '0',
      erji_rebate_rate: '0',
      sanji_rebate_rate: '0',
      friend_rebate_freeze_time: '0'
    }
  }
  private antDisabled: boolean = false
  private async antSave() {
    try {
      this.antDisabled = true
      let data: any = {
        ssl_switch: {
          ...this.baseForm
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.antDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.antDisabled = false
      this.getEnterprise()
    }
  }

  private rules = newSettingRules
  private enterpriseRules = exchangeRateRules
  private loading: boolean = false

  private getLogo(logo: string) {
    this.setForm.site_logo = logo
  }

  private async setStatus() {
    const ops: any = {
      title: 'Task Description',
      key: 'description',
      fn: this.setGoogleAuth,
      params: { google_auth_switch: this.form.google_auth_switch },
      authCode: 'change_enterprise_google_auth'
    }
    reqInterceptors(ops)
  }

  private setIp: boolean = false
  private async changeMerchantIP() {
    try {
      this.setIp = true
      const data: any = {
        ssl_switch: {
          disable_merchant_set_ip_whitelist:
            this.setForm.disable_merchant_set_ip_whitelist
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.setIp = false
      })
    } catch (e) {
      console.log()
    }
  }

  private async setBotStatus() {
    MessageBox.prompt('Task Description：', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      inputPlaceholder: 'change_enterprise_bot_google_auth',
      // inputValidator: function(v) { return v !== null && (v + '').length > 0 },
      inputPattern: /^.{1,100}$/,
      inputErrorMessage: 'Please enter description!'
    }).then(({ value }: any) => {
      let data = {
        description: value,
        bot_google_auth_switch: this.form.bot_google_auth_switch
      }
      this.changeBotGoogleAuth(data)
    })
  }

  private clipboardSuccess() {
    this.$message({
      message: 'Copy successfully',
      type: 'success',
      duration: 2000
    })
  }

  // 运维机器人 Token
  private devBotTokenVis: boolean = false
  private openDevBotToken() {
    this.devBotTokenVis = true
  }
  private closeDevBotToken() {
    this.devBotTokenVis = false
  }

  // 商户机器人 Token
  private botTokenVisible: boolean = false
  private openBotToken() {
    this.botTokenVisible = true
  }
  private closeBotToken() {
    this.botTokenVisible = false
  }

  // 商户机器人 Token
  private fpBotTokenVisible: boolean = false
  private openFpBotToken() {
    this.fpBotTokenVisible = true
  }
  private closeFpBotToken() {
    this.fpBotTokenVisible = false
  }

  // 发送 Telegram 群消息
  private sendMesVisible: boolean = false
  private openSendMes() {
    this.sendMesVisible = true
    this.$nextTick(() => {
      let el: any = this.$refs['sendMesBtn']
      el.init()
    })
  }
  private closeSendMes() {
    this.sendMesVisible = false
  }

  // 节假日结算延期
  private delayVisible: boolean = false
  private openDelay() {
    this.delayVisible = true
  }

  // 风控开关弹窗
  private openControlVisible: boolean = false
  private openControl() {
    this.openControlVisible = true
  }

  private async editWindowHours() {
    const data: any = {
      ssl_switch: {
        payout_risk_duplicate_account_window_hours:
          this.setForm.payout_risk_duplicate_account_window_hours,
        payout_risk_duplicate_account_max_count:
          this.setForm.payout_risk_duplicate_account_max_count,
        payout_risk_duplicate_account_min_amount:
          this.setForm.payout_risk_duplicate_account_min_amount
      }
    }
    await setEnterprise(data).then((res: any) => {
      this.$message({
        message: 'Operation Successfully!',
        type: 'success'
      })
      this.closeWindowHours()
    })
  }
  private closeWindowHours() {
    this.openControlVisible = false
  }

  // 已绑定群
  private isDrawerVisible: any = false
  private openBoundGroup() {
    this.isDrawerVisible = true
  }

  private async setExchangeSwitch() {
    const data: any = {
      ssl_switch: {
        exchange_switch: this.setForm.exchange_switch
      }
    }
    await setEnterprise(data).then((res: any) => {
      this.$message({
        message: 'Operation Successfully!',
        type: 'success'
      })
    })
  }

  // 换汇开关
  private exchangeVisible: boolean = false
  private openExchangeEdit() {
    this.exchangeVisible = true
  }

  private closeExchangeEdit() {
    this.exchangeVisible = false
  }

  private async editExchange() {
    try {
      const data: any = {
        ssl_switch: {
          fp_chat_id: this.setForm.fp_chat_id
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.closeExchangeEdit()
      })
    } catch (error) {}
  }

  // FP绑定群
  private openFpBoundGroup() {
    this.isDrawerVisible = true
  }

  // 账户转发已绑定群
  private isDrawerVisible2: any = false
  private openForward() {
    this.isDrawerVisible2 = true
  }

  // 已绑定群
  private isComdsOrder: any = false
  private openComdsOrder() {
    this.isComdsOrder = true
  }
  private closeComdsOrder(val) {
    this.isComdsOrder = false
    this.getEnterprise()
  }

  // 编辑 商户机器人token
  private async editBotToken() {
    try {
      const data: any = {
        ssl_switch: {
          telegram_robot_token: this.setForm.telegram_robot_token
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        if (
          res.ssl_switch.telegram_robot_username !== '' &&
          res.ssl_switch.telegram_robot_username !== undefined &&
          res.ssl_switch.telegram_robot_username !== null
        ) {
          this.setForm.telegram_robot_username =
            '@' + res.ssl_switch.telegram_robot_username
        } else {
          this.setForm.telegram_robot_username =
            res.ssl_switch.telegram_robot_username
        }
        this.setForm.telegram_robot_firstname =
          res.ssl_switch.telegram_robot_firstname
        this.closeBotToken()
      })
    } catch (e) {
      console.log()
    }
  }

  // 编辑 Fp机器人token
  private async editFpBotToken() {
    const data: any = {
      ssl_switch: {
        fp_robot_token: this.setForm.fp_robot_token
      }
    }
    await setEnterprise(data).then((res: any) => {
      this.$message({
        message: 'Operation Successfully!',
        type: 'success'
      })
      if (
        res.ssl_switch.fp_robot_username !== '' &&
        res.ssl_switch.fp_robot_username !== undefined &&
        res.ssl_switch.fp_robot_username !== null
      ) {
        this.setForm.fp_robot_username = '@' + res.ssl_switch.fp_robot_username
      } else {
        this.setForm.fp_robot_username = res.ssl_switch.fp_robot_username
      }
      this.setForm.fp_robot_firstname = res.ssl_switch.fp_robot_firstname
      this.closeFpBotToken()
    })
  }

  // 修改凭证样式
  private async editBotStyle() {
    try {
      this.setIp = true
      const data: any = {
        ssl_switch: {
          bot_cert_style: this.setForm.bot_cert_style
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.setIp = false
      })
    } catch (e) {
      console.log()
      this.setIp = false
    }
  }

  // 编辑 运维机器人token
  private async editDevBotToken() {
    try {
      const data: any = {
        ssl_switch: {
          telegram_devops_robot_token: this.setForm.telegram_devops_robot_token
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        if (
          res.ssl_switch.telegram_devops_robot_username !== '' &&
          res.ssl_switch.telegram_devops_robot_username !== undefined &&
          res.ssl_switch.telegram_devops_robot_username !== null
        ) {
          this.setForm.telegram_devops_robot_username =
            '@' + res.ssl_switch.telegram_devops_robot_username
        } else {
          this.setForm.telegram_devops_robot_username =
            res.ssl_switch.telegram_devops_robot_username
        }
        this.setForm.telegram_devops_robot_firstname =
          res.ssl_switch.telegram_devops_robot_firstname
        this.closeDevBotToken()
      })
    } catch (e) {
      console.log()
    }
  }

  // 代付通知输入查询Telegram群ID方法
  private queryTgGroup(index: number) {
    this.queryTgGroupId(index)
  }

  // USDT通知输入查询Telegram群ID方法
  private queryUsdtTgGroup(index: number) {
    this.queryTgGroupId(index)
  }

  // thai通知输入查询Telegram群ID方法
  private thaiTgGroup(index: number) {
    this.queryThaiGroupId(index)
  }

  // inr通知输入查询Telegram群ID方法
  private inrTgGroup(index: number) {
    this.queryInrGroupId(index)
  }

  // 查询代付通知Telegram群ID
  private groupId: any = null
  private async queryTgGroupId(index) {
    try {
      const data: any = {
        group_name: this.setForm.group_name
      }
      await searchTelegramGroup(data)
        .then((res: any) => {
          this.groupId = res.group_id
          this.$set(
            this.setForm.notify_withdraw_telegram_group_id,
            index,
            this.groupId
          )
        })
        .catch((e: any) => {
          this.groupId = ''
        })
    } catch (e) {
      console.log()
    }
  }

  // 查询thia通知Telegram群ID
  private thaiGroupId: any = null
  private async queryThaiGroupId(index) {
    try {
      const data: any = {
        group_name: this.setForm.group_name
      }
      await searchTelegramGroup(data)
        .then((res: any) => {
          this.thaiGroupId = res.group_id
          this.$set(
            this.setForm.thai_notify_telegram_group,
            index,
            this.thaiGroupId
          )
        })
        .catch((e: any) => {
          this.thaiGroupId = ''
        })
    } catch (e) {
      console.log()
    }
  }

  // 查询inr通知Telegram群ID
  private inrGroupId: any = null
  private async queryInrGroupId(index) {
    try {
      const data: any = {
        group_name: this.setForm.group_name
      }
      await searchTelegramGroup(data)
        .then((res: any) => {
          this.inrGroupId = res.group_id
          this.$set(
            this.setForm.thai_notify_telegram_group,
            index,
            this.inrGroupId
          )
        })
        .catch((e: any) => {
          this.inrGroupId = ''
        })
    } catch (e) {
      console.log()
    }
  }

  // 代付声效开关
  private async notifySwitch(value: string) {
    try {
      let sslSwitch: any = {}
      sslSwitch[value] = this.setForm[value]
      const data = {
        ssl_switch: sslSwitch
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
      })
    } catch (e) {}
  }

  // 按钮只触发一次
  private flag: boolean = false
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async setGoogleAuth(data) {
    try {
      await setGoogleAuth(data).then((res: any) => {
        operationMessage(
          checkNeedAudit('change_enterprise_google_auth') !== undefined
        )
      })
    } catch (e) {
      console.log()
    } finally {
      this.form.google_auth_switch = !this.form.google_auth_switch
    }
  }

  private async changeBotGoogleAuth(data) {
    try {
      await setBotGoogleAuth(data).then((res: any) => {
        // operationMessage(
        //   checkNeedAudit('change_enterprise_bot_google_auth') !== undefined
        // )
      })
    } catch (e) {
      console.log()
    } finally {
      this.getEnterprise()
      // this.form.bot_google_auth_switch = !this.form.bot_google_auth_switch
    }
  }

  private async setsiteName() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        const data: any = {
          ssl_switch: {
            site_name: this.setForm.site_name
          }
        }
        await setEnterprise(data).then((res: any) => {
          if (this.language === 'en') {
            this.$message({
              message: 'Operation Successfully!',
              type: 'success'
            })
          } else if (this.language === 'zh_cn') {
            this.$message({
              message: '操作成功!',
              type: 'success'
            })
          } else if (this.language === 'zh_tw') {
            this.$message({
              message: '操作成功!',
              type: 'success'
            })
          }

          this.showSiteName = false
          this.loading = false
          this.getEnterprise()
          window.location.reload()
        })
      } else {
        return false
      }
    })
  }

  private async setsiteLogo() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        const data: any = {
          ssl_switch: {
            site_logo: this.setForm.site_logo
          }
        }
        await setEnterprise(data).then((res: any) => {
          if (this.language === 'en') {
            this.$message({
              message: 'Operation Successfully!',
              type: 'success'
            })
          } else if (this.language === 'zh_cn') {
            this.$message({
              message: '操作成功!',
              type: 'success'
            })
          } else if (this.language === 'zh_tw') {
            this.$message({
              message: '操作成功!',
              type: 'success'
            })
          }
          this.showSiteLogo = false
          this.loading = false
          this.getEnterprise()
          if (res.ssl_switch.site_logo && res.ssl_switch.site_logo !== '') {
            AppModule.SetSiteLogo(res.ssl_switch.site_logo)
          }
          window.location.reload()
        })
      } else {
        return false
      }
    })
  }

  private async setMerchantNo() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            test_merchant_no: this.setForm.test_merchant_no,
            description: this.setForm.description
          }
          await setEnterprise(data).then((res: any) => {
            this.$message({
              message: 'Operation Successfully!',
              type: 'success'
            })
            this.dialogVisible = false
            this.loading = false
            this.getEnterprise()
          })
        } catch (e) {
          console.log()
        }
      }
    })
  }

  private async setEnterprise() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            checkout_counter_domain: this.setForm.checkout_counter_domain,
            description: this.setForm.description
          }
          await setEnterprise(data).then((res: any) => {
            operationMessage(checkNeedAudit('change_enterprise') !== undefined)
            this.form = res
            this.dialogVisibles = false
            this.loading = false
            this.getEnterprise()
          })
        } catch (e) {
          this.loading = false
        }
      }
    })
  }

  // sale
  private saleDisabled: boolean = false
  private async getSaleSave() {
    try {
      this.saleDisabled = true
      let data: any = {
        ssl_switch: {
          sale_usdt_rate: this.baseForm.sale_usdt_rate,
          in_maintain: this.baseForm.in_maintain,
          collection_balance_freeze_hours:
            this.baseForm.collection_balance_freeze_hours
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.saleDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  // Exchange
  private exchangeDisabled: boolean = false
  private async getExchangeSave() {
    try {
      this.saleDisabled = true
      let data: any = {
        ssl_switch: {
          exchange_usdt_rate: this.baseForm.exchange_usdt_rate,
          exchange_balance_freeze_hours:
            this.baseForm.exchange_balance_freeze_hours,
          exchange_in_maintain: this.baseForm.exchange_in_maintain
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.saleDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  // Topup
  private topupDisabled: boolean = false
  private async getTopupSave() {
    try {
      this.topupDisabled = true
      let data: any = {
        ssl_switch: {
          ant_withdraw_fee: {
            fix_fee: this.baseForm.ant_withdraw_fee.fix_fee,
            rate: this.baseForm.ant_withdraw_fee.rate
          },
          ant_erc20_withdraw_fee: {
            fix_fee: this.baseForm.ant_erc20_withdraw_fee.fix_fee,
            rate: this.baseForm.ant_erc20_withdraw_fee.rate
          },
          buy_platform_usdt_rate: this.baseForm.buy_platform_usdt_rate,
          topup_freeze: this.baseForm.topup_freeze,
          wallet_reset_duration: this.baseForm.wallet_reset_duration,
          buy_platform_usdt_min_amount:
            this.baseForm.buy_platform_usdt_min_amount,
          ant_wallet_type: {
            ant_erc20: this.baseForm.ant_wallet_type.ant_erc20,
            ant_trc20: this.baseForm.ant_wallet_type.ant_trc20,
            ant_inr: this.baseForm.ant_wallet_type.ant_inr
          }
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.topupDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  // Other
  private otherDisabled: boolean = false
  private async getOtherSave() {
    try {
      this.otherDisabled = true
      let data: any = {
        ssl_switch: {
          kefu_link: this.baseForm.kefu_link,
          register_apply_switch: this.baseForm.register_apply_switch,
          register_switch: this.baseForm.register_switch,
          wallet_delete_switch: this.baseForm.wallet_delete_switch,
          telegram_switch: this.baseForm.telegram_switch,
          whatsapp_switch: this.baseForm.whatsapp_switch
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.otherDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  // buy
  private buyDisabled: boolean = false
  private async getBuySave() {
    try {
      this.buyDisabled = true
      let data: any = {
        ssl_switch: {
          ant_withdraw_max_order_count:
            this.baseForm.ant_withdraw_max_order_count,
          ant_withdraw_expire_min: this.baseForm.ant_withdraw_expire_min,
          buy_freeze: this.baseForm.buy_freeze,
          buy_usdt_rate: this.baseForm.buy_usdt_rate,
          close_buy: this.baseForm.close_buy
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.buyDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  // name
  private async getNameSave() {
    try {
      this.baseDisabled = true
      let data: any = {
        ssl_switch: {
          merchant_deposit_settlment_rate:
            this.baseForm.merchant_deposit_settlment_rate,
          merchant_payout_settlment_rate:
            this.baseForm.merchant_payout_settlment_rate,
          merchant_exchange_settlment_rate:
            this.baseForm.merchant_exchange_settlment_rate
        }
      }
      await setEnterprise(data).then(() => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.baseDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.baseDisabled = false
      this.getEnterprise()
    }
  }

  private geogleStatus: any = 0
  private async onloadAntGoogleAuth() {
    try {
      await getAntGoogleAuth().then((res: any) => {
        this.geogleStatus = res.ant_google_switch
      })
    } catch (e) {}
  }
  private geogle: any = {
    action: '',
    google_code: ''
  }
  private geogleShow: any = false
  private geogleStatusSwitch(val) {
    if (val === 1) {
      this.changeGeogleStatus()
    } else {
      if (this.language === 'en') {
        this.$message({
          message: 'Use the Modify button to turn off Google verification!',
          type: 'error'
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '请通过修改按钮关闭谷歌验证!',
          type: 'error'
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '請通過修改按鈕關閉谷歌驗證!',
          type: 'error'
        })
      }
      this.onloadAntGoogleAuth()
    }
  }
  private geogleStatusBtn(val) {
    this.geogleShow = true
  }
  private async changeGeogleStatus() {
    try {
      this.loading = true
      let data: any = {}
      if (!this.geogle.google_code) {
        data = {
          action: 'open'
        }
      } else {
        data = {
          action: this.geogle.action,
          google_code: this.geogle.google_code
        }
      }
      await changeAntGoogleAuth(data).then((res: any) => {
        this.geogleStatus = res.ant_google_switch
        this.closeGeogle()
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }
  private closeGeogle() {
    this.geogle = {
      action: '',
      google_code: ''
    }
    this.geogleShow = false
    this.onloadAntGoogleAuth()
  }

  private enterpriseData: any = {}
  private async getEnterprise() {
    try {
      await getEnterprise().then((res: any) => {
        this.enterpriseData = res
        this.setForm.payout_notify_switch = res.ssl_switch.payout_notify_switch
        this.setForm.ant_payout_payment_switch =
          res.ssl_switch.ant_payout_payment_switch
        this.setForm.auto_refund = res.ssl_switch.auto_refund
        this.setForm.merchant_login_google_auth_switch =
          res.ssl_switch.merchant_login_google_auth_switch
        this.setForm.merchant_backoffice_payout_switch =
          res.ssl_switch.merchant_backoffice_payout_switch
        this.setForm.payout_risk_duplicate_account_switch = res.ssl_switch
          .payout_risk_duplicate_account_switch
          ? res.ssl_switch.payout_risk_duplicate_account_switch
          : 0
        this.setForm.notify_withdraw_switch =
          res.ssl_switch.notify_withdraw_switch
        this.setForm.notify_usdt_collect_switch =
          res.ssl_switch.notify_usdt_collect_switch
        this.setForm.holidays_settlement_time_switch =
          res.ssl_switch.holidays_settlement_time_switch
        this.setForm.thai_notify_switch = res.ssl_switch.thai_notify_switch
        this.setForm.inr_notify_switch = res.ssl_switch.inr_notify_switch
        this.setForm.account_rate_notify_switch =
          res.ssl_switch.account_rate_notify_switch
        this.setForm.php_notify_switch = res.ssl_switch.php_notify_switch
        this.setForm.eur_notify_switch = res.ssl_switch.eur_notify_switch
        this.setForm.ngn_notify_switch = res.ssl_switch.ngn_notify_switch
        this.setForm.rm_notify_switch = res.ssl_switch.rm_notify_switch

        this.setForm.gcash_notify_switch =
          res.ssl_switch.gcash_notify_switch === 0 ? 0 : 1
        this.setForm.usd_cap_notify_switch =
          res.ssl_switch.usd_cap_notify_switch === 0 ? 0 : 1
        this.setForm.ant_limit_notify_switch =
          res.ssl_switch.ant_limit_notify_switch === 0 ? 0 : 1
        this.setForm.ant_register_notify_switch =
          res.ssl_switch.ant_register_notify_switch === 0 ? 0 : 1
        this.setForm.telegram_robot_token = res.ssl_switch.telegram_robot_token
        this.setForm.bot_cert_style = res.ssl_switch.bot_cert_style
        this.setForm.fp_robot_token = res.ssl_switch.fp_robot_token
        this.setForm.payout_risk_duplicate_account_window_hours =
          res.ssl_switch.payout_risk_duplicate_account_window_hours
        this.setForm.payout_risk_duplicate_account_max_count =
          res.ssl_switch.payout_risk_duplicate_account_max_count
        this.setForm.payout_risk_duplicate_account_min_amount =
          res.ssl_switch.payout_risk_duplicate_account_min_amount

        if (this.enterpriseData.enterprise_type === 'ant') {
          this.onloadAntGoogleAuth()
        }
        res.ssl_switch.test_order_notify_switch
          ? (this.setForm.test_order_notify_switch = 1)
          : (this.setForm.test_order_notify_switch = 0)

        res.ssl_switch.telegram_account_switch
          ? (this.setForm.telegram_account_switch = 1)
          : (this.setForm.telegram_account_switch = 0)

        res.ssl_switch.photo_switch === 0
          ? (this.setForm.photo_switch = 0)
          : (this.setForm.photo_switch = 1)

        res.ssl_switch.asyn_photo_switch === 0
          ? (this.setForm.asyn_photo_switch = 0)
          : (this.setForm.asyn_photo_switch = 1)

        res.ssl_switch.api_error_switch
          ? (this.setForm.api_error_switch = 1)
          : (this.setForm.api_error_switch = 0)

        res.ssl_switch.api_sms_switch
          ? (this.setForm.api_sms_switch = 1)
          : (this.setForm.api_sms_switch = 0)

        res.ssl_switch.rm_deposit_notify_switch
          ? (this.setForm.rm_deposit_notify_switch = 1)
          : (this.setForm.rm_deposit_notify_switch = 0)

        res.ssl_switch.rm_payout_notify_switch
          ? (this.setForm.rm_payout_notify_switch = 1)
          : (this.setForm.rm_payout_notify_switch = 0)

        res.ssl_switch.rm_collect_notify_switch
          ? (this.setForm.rm_collect_notify_switch = 1)
          : (this.setForm.rm_collect_notify_switch = 0)

        res.ssl_switch.fp_bot_switch
          ? (this.setForm.fp_bot_switch = 1)
          : (this.setForm.fp_bot_switch = 0)

        res.ssl_switch.bot_cars_switch === 1
          ? (this.setForm.bot_cars_switch = 1)
          : (this.setForm.bot_cars_switch = 0)

        res.ssl_switch.exchange_switch === 1
          ? (this.setForm.exchange_switch = 1)
          : (this.setForm.exchange_switch = 0)

        if (res.ssl_switch.fp_chat_id) {
          this.setForm.fp_chat_id = res.ssl_switch.fp_chat_id
        } else {
          this.setForm.fp_chat_id = ''
        }

        if (res.ssl_switch.clave_notify_switch) {
          this.setForm.clave_notify_switch = 1
        } else {
          this.setForm.clave_notify_switch = 0
        }
        this.setForm.telegram_devops_robot_token =
          res.ssl_switch.telegram_devops_robot_token
        if (
          res.ssl_switch.telegram_robot_username !== '' &&
          res.ssl_switch.telegram_robot_username !== undefined &&
          res.ssl_switch.telegram_robot_username !== null
        ) {
          this.setForm.telegram_robot_username =
            '@' + res.ssl_switch.telegram_robot_username
        } else {
          this.setForm.telegram_robot_username =
            res.ssl_switch.telegram_robot_username
        }

        if (
          res.ssl_switch.fp_robot_username !== '' &&
          res.ssl_switch.fp_robot_username !== undefined &&
          res.ssl_switch.fp_robot_username !== null
        ) {
          this.setForm.fp_robot_username =
            '@' + res.ssl_switch.fp_robot_username
        } else {
          this.setForm.fp_robot_username = res.ssl_switch.fp_robot_username
        }

        if (res.ssl_switch.telegram_account_username !== '') {
          this.setForm.telegram_account_username =
            res.ssl_switch.telegram_account_username
        }
        if (res.ssl_switch.telegram_api_hash !== '') {
          this.setForm.telegram_api_hash = res.ssl_switch.telegram_api_hash
        }
        if (res.ssl_switch.telegram_api_id !== '') {
          this.setForm.telegram_api_id = res.ssl_switch.telegram_api_id
        }
        if (res.ssl_switch.telegram_account_name !== '') {
          this.setForm.telegram_account_name =
            res.ssl_switch.telegram_account_name
        }
        this.setForm.telegram_robot_firstname =
          res.ssl_switch.telegram_robot_firstname
        if (
          res.ssl_switch.telegram_devops_robot_username !== '' &&
          res.ssl_switch.telegram_devops_robot_username !== undefined &&
          res.ssl_switch.telegram_devops_robot_username !== null
        ) {
          this.setForm.telegram_devops_robot_username =
            '@' + res.ssl_switch.telegram_devops_robot_username
        } else {
          this.setForm.telegram_devops_robot_username =
            res.ssl_switch.telegram_devops_robot_username
        }
        this.setForm.telegram_devops_robot_firstname =
          res.ssl_switch.telegram_devops_robot_firstname
        this.setForm.fp_robot_firstname = res.ssl_switch.fp_robot_firstname
        if (res.ssl_switch.buy_usdt_rate) {
          this.baseForm.buy_usdt_rate = res.ssl_switch.buy_usdt_rate
        } else {
          this.baseForm.buy_usdt_rate = '0'
        }
        if (res.ssl_switch.close_buy) {
          this.baseForm.close_buy = res.ssl_switch.close_buy
        } else {
          this.baseForm.close_buy = 0
        }
        if (res.ssl_switch.sale_usdt_rate) {
          this.baseForm.sale_usdt_rate = res.ssl_switch.sale_usdt_rate
        } else {
          this.baseForm.sale_usdt_rate = '0'
        }
        if (res.ssl_switch.collection_balance_freeze_hours) {
          this.baseForm.collection_balance_freeze_hours =
            res.ssl_switch.collection_balance_freeze_hours
        } else {
          this.baseForm.collection_balance_freeze_hours = '0'
        }
        if (res.ssl_switch.exchange_usdt_rate) {
          this.baseForm.exchange_usdt_rate = res.ssl_switch.exchange_usdt_rate
        } else {
          this.baseForm.exchange_usdt_rate = '0'
        }
        if (res.ssl_switch.exchange_balance_freeze_hours) {
          this.baseForm.exchange_balance_freeze_hours =
            res.ssl_switch.exchange_balance_freeze_hours
        } else {
          this.baseForm.exchange_balance_freeze_hours = '0'
        }
        if (res.ssl_switch.buy_platform_usdt_rate) {
          this.baseForm.buy_platform_usdt_rate =
            res.ssl_switch.buy_platform_usdt_rate
        } else {
          this.baseForm.buy_platform_usdt_rate = ''
        }
        if (res.ssl_switch.topup_freeze) {
          this.baseForm.topup_freeze = res.ssl_switch.topup_freeze
        } else {
          this.baseForm.topup_freeze = 0
        }
        if (res.ssl_switch.wallet_reset_duration) {
          this.baseForm.wallet_reset_duration =
            res.ssl_switch.wallet_reset_duration
        } else {
          this.baseForm.wallet_reset_duration = 2
        }
        if (res.ssl_switch.buy_platform_usdt_min_amount) {
          this.baseForm.buy_platform_usdt_min_amount =
            res.ssl_switch.buy_platform_usdt_min_amount
        } else {
          this.baseForm.buy_platform_usdt_min_amount = ''
        }
        if (res.ssl_switch.merchant_deposit_settlment_rate) {
          this.baseForm.merchant_deposit_settlment_rate =
            res.ssl_switch.merchant_deposit_settlment_rate
        } else {
          this.baseForm.merchant_deposit_settlment_rate = ''
        }
        if (res.ssl_switch.merchant_payout_settlment_rate) {
          this.baseForm.merchant_payout_settlment_rate =
            res.ssl_switch.merchant_payout_settlment_rate
        } else {
          this.baseForm.merchant_payout_settlment_rate = ''
        }
        if (res.ssl_switch.merchant_exchange_settlment_rate) {
          this.baseForm.merchant_exchange_settlment_rate =
            res.ssl_switch.merchant_exchange_settlment_rate
        } else {
          this.baseForm.merchant_exchange_settlment_rate = ''
        }
        // 不可用银行
        this.antBankList = res.ant_product
        if (
          res.ssl_switch.in_maintain &&
          res.ssl_switch.in_maintain.length > 0
        ) {
          this.baseForm.in_maintain = res.ssl_switch.in_maintain
        } else {
          this.baseForm.in_maintain = []
        }
        if (
          res.ssl_switch.exchange_in_maintain &&
          res.ssl_switch.exchange_in_maintain.length > 0
        ) {
          this.baseForm.exchange_in_maintain =
            res.ssl_switch.exchange_in_maintain
        } else {
          this.baseForm.exchange_in_maintain = []
        }
        if (res.ssl_switch.kefu_link) {
          this.baseForm.kefu_link = res.ssl_switch.kefu_link
        } else {
          this.baseForm.kefu_link = ''
        }
        if (res.ssl_switch.register_switch) {
          this.baseForm.register_switch = res.ssl_switch.register_switch
        } else {
          this.baseForm.register_switch = ''
        }
        if (res.ssl_switch.register_apply_switch) {
          this.baseForm.register_apply_switch =
            res.ssl_switch.register_apply_switch
        } else {
          this.baseForm.register_apply_switch = ''
        }

        if (res.ssl_switch.wallet_delete_switch) {
          this.baseForm.wallet_delete_switch =
            res.ssl_switch.wallet_delete_switch
        } else {
          this.baseForm.wallet_delete_switch = 0
        }
        if (res.ssl_switch.whatsapp_switch) {
          this.baseForm.whatsapp_switch = res.ssl_switch.whatsapp_switch
        } else {
          this.baseForm.whatsapp_switch = '0'
        }
        if (res.ssl_switch.telegram_switch) {
          this.baseForm.telegram_switch = res.ssl_switch.telegram_switch
        } else {
          this.baseForm.telegram_switch = '0'
        }
        if (res.ssl_switch.ant_withdraw_fee) {
          this.baseForm.ant_withdraw_fee.fix_fee =
            res.ssl_switch.ant_withdraw_fee.fix_fee
          this.baseForm.ant_withdraw_fee.rate =
            res.ssl_switch.ant_withdraw_fee.rate
        } else {
          this.baseForm.ant_withdraw_fee.fix_fee = 0
          this.baseForm.ant_withdraw_fee.rate = 0
        }
        if (res.ssl_switch.ant_wallet_type) {
          res.ssl_switch.ant_wallet_type.ant_erc20
            ? (this.baseForm.ant_wallet_type.ant_erc20 =
                res.ssl_switch.ant_wallet_type.ant_erc20)
            : (this.baseForm.ant_wallet_type.ant_erc20 = 0)
          res.ssl_switch.ant_wallet_type.ant_trc20
            ? (this.baseForm.ant_wallet_type.ant_trc20 =
                res.ssl_switch.ant_wallet_type.ant_trc20)
            : (this.baseForm.ant_wallet_type.ant_trc20 = 0)
          res.ssl_switch.ant_wallet_type.ant_inr
            ? (this.baseForm.ant_wallet_type.ant_inr =
                res.ssl_switch.ant_wallet_type.ant_inr)
            : (this.baseForm.ant_wallet_type.ant_inr = 0)
        } else {
          this.baseForm.ant_wallet_type.ant_erc20 = 1
          this.baseForm.ant_wallet_type.ant_trc20 = 1
          this.baseForm.ant_wallet_type.ant_inr = 1
        }
        if (res.ssl_switch.ant_erc20_withdraw_fee) {
          this.baseForm.ant_erc20_withdraw_fee.fix_fee =
            res.ssl_switch.ant_erc20_withdraw_fee.fix_fee
          this.baseForm.ant_erc20_withdraw_fee.rate =
            res.ssl_switch.ant_erc20_withdraw_fee.rate
        } else {
          this.baseForm.ant_erc20_withdraw_fee.fix_fee = 0
          this.baseForm.ant_erc20_withdraw_fee.rate = 0
        }

        if (res.ssl_switch.sale_usdt_rebate_rate) {
          this.rebateForm.sale_usdt_rebate_rate =
            res.ssl_switch.sale_usdt_rebate_rate
        } else {
          this.rebateForm.sale_usdt_rebate_rate = '0'
        }

        if (res.ssl_switch.buy_usdt_rebate_rate) {
          this.rebateForm.buy_usdt_rebate_rate =
            res.ssl_switch.buy_usdt_rebate_rate
        } else {
          this.rebateForm.buy_usdt_rebate_rate = '0'
        }
        res.ssl_switch.exchange_usdt_rebate_rate
          ? (this.rebateForm.exchange_usdt_rebate_rate =
              res.ssl_switch.exchange_usdt_rebate_rate)
          : (this.rebateForm.exchange_usdt_rebate_rate = '0')
        res.ssl_switch.exchange_rebate_freeze_time
          ? (this.rebateForm.exchange_rebate_freeze_time =
              res.ssl_switch.exchange_rebate_freeze_time)
          : (this.rebateForm.exchange_rebate_freeze_time = '0')
        if (res.ssl_switch.sale_rebate_freeze_time) {
          this.rebateForm.sale_rebate_freeze_time =
            res.ssl_switch.sale_rebate_freeze_time
        } else {
          this.rebateForm.sale_rebate_freeze_time = '0'
        }

        if (res.ssl_switch.buy_rebate_freeze_time) {
          this.rebateForm.buy_rebate_freeze_time =
            res.ssl_switch.buy_rebate_freeze_time
        } else {
          this.rebateForm.buy_rebate_freeze_time = '0'
        }

        if (res.ssl_switch.yiji_rebate_rate) {
          this.suggestForm.yiji_rebate_rate = res.ssl_switch.yiji_rebate_rate
        } else {
          this.suggestForm.yiji_rebate_rate = '0'
        }
        if (res.ssl_switch.erji_rebate_rate) {
          this.suggestForm.erji_rebate_rate = res.ssl_switch.erji_rebate_rate
        } else {
          this.suggestForm.erji_rebate_rate = '0'
        }
        if (res.ssl_switch.sanji_rebate_rate) {
          this.suggestForm.sanji_rebate_rate = res.ssl_switch.sanji_rebate_rate
        } else {
          this.suggestForm.sanji_rebate_rate = '0'
        }
        if (res.ssl_switch.friend_rebate_freeze_time) {
          this.suggestForm.friend_rebate_freeze_time =
            res.ssl_switch.friend_rebate_freeze_time
        } else {
          this.suggestForm.friend_rebate_freeze_time = '0'
        }

        if (res.ssl_switch.notify_withdraw_telegram_group_id) {
          this.setForm.notify_withdraw_telegram_group_id =
            res.ssl_switch.notify_withdraw_telegram_group_id
        }
        if (res.ssl_switch.telegram_group_id) {
          this.setForm.telegram_group_id = res.ssl_switch.telegram_group_id
        }
        if (res.ssl_switch.thai_notify_telegram_group) {
          this.setForm.thai_notify_telegram_group =
            res.ssl_switch.thai_notify_telegram_group
        }
        if (res.ssl_switch.account_rate_notify_telegram_group) {
          this.setForm.account_rate_notify_telegram_group =
            res.ssl_switch.account_rate_notify_telegram_group
        }
        if (res.ssl_switch.inr_notify_telegram_group) {
          this.setForm.inr_notify_telegram_group =
            res.ssl_switch.inr_notify_telegram_group
        }
        if (res.ssl_switch.php_notify_telegram_group) {
          this.setForm.php_notify_telegram_group =
            res.ssl_switch.php_notify_telegram_group
        }
        if (res.ssl_switch.eur_notify_telegram_group) {
          this.setForm.eur_notify_telegram_group =
            res.ssl_switch.eur_notify_telegram_group
        }
        if (res.ssl_switch.ngn_notify_telegram_group) {
          this.setForm.ngn_notify_telegram_group =
            res.ssl_switch.ngn_notify_telegram_group
        }
        if (res.ssl_switch.rm_notify_telegram_group) {
          this.setForm.rm_notify_telegram_group =
            res.ssl_switch.rm_notify_telegram_group
        }
        if (res.ssl_switch.api_error_notify_telegram_group) {
          this.setForm.api_error_notify_telegram_group =
            res.ssl_switch.api_error_notify_telegram_group
        }
        if (res.ssl_switch.api_sms_notify_telegram_group) {
          this.setForm.api_sms_notify_telegram_group =
            res.ssl_switch.api_sms_notify_telegram_group
        }
        if (res.ssl_switch.rm_deposit_notify_telegram_group) {
          this.setForm.rm_deposit_notify_telegram_group =
            res.ssl_switch.rm_deposit_notify_telegram_group
        }
        if (res.ssl_switch.rm_payout_notify_telegram_group) {
          this.setForm.rm_payout_notify_telegram_group =
            res.ssl_switch.rm_payout_notify_telegram_group
        }
        if (res.ssl_switch.rm_collect_notify_telegram_group) {
          this.setForm.rm_collect_notify_telegram_group =
            res.ssl_switch.rm_collect_notify_telegram_group
        }
        if (res.ssl_switch.fp_telegram_group) {
          this.setForm.fp_telegram_group = res.ssl_switch.fp_telegram_group
        }
        if (res.ssl_switch.gcash_notify_telegram_group) {
          this.setForm.gcash_notify_telegram_group =
            res.ssl_switch.gcash_notify_telegram_group
        }
        if (res.ssl_switch.usd_cap_notify_telegram_group) {
          this.setForm.usd_cap_notify_telegram_group =
            res.ssl_switch.usd_cap_notify_telegram_group
        }
        if (res.ssl_switch.ant_limit_notify_telegram_group) {
          this.setForm.ant_limit_notify_telegram_group =
            res.ssl_switch.ant_limit_notify_telegram_group
        }
        if (res.ssl_switch.ant_register_telegram_group) {
          this.setForm.ant_register_telegram_group =
            res.ssl_switch.ant_register_telegram_group
        }
        if (
          res.ssl_switch.safety_notify_switch ||
          res.ssl_switch.safety_notify_switch === 0
        ) {
          this.setForm.safety_notify_switch =
            res.ssl_switch.safety_notify_switch
        } else {
          this.setForm.safety_notify_switch = 1
        }
        if (res.ssl_switch.safety_notify_telegram_group) {
          this.setForm.safety_notify_telegram_group =
            res.ssl_switch.safety_notify_telegram_group
        }
        if (res.ssl_switch.telegram_robot_comds) {
          this.setForm.telegram_robot_comds =
            res.ssl_switch.telegram_robot_comds
        } else {
          this.setForm.telegram_robot_comds = []
        }
        if (res.ssl_switch.ant_withdraw_max_order_count) {
          this.baseForm.ant_withdraw_max_order_count =
            res.ssl_switch.ant_withdraw_max_order_count
        } else {
          this.baseForm.ant_withdraw_max_order_count = '1'
        }
        if (res.ssl_switch.ant_withdraw_expire_min) {
          this.baseForm.ant_withdraw_expire_min =
            res.ssl_switch.ant_withdraw_expire_min
        } else {
          this.baseForm.ant_withdraw_expire_min = '10'
        }

        if (res.ssl_switch.buy_freeze) {
          this.baseForm.buy_freeze = res.ssl_switch.buy_freeze
        } else {
          this.baseForm.buy_freeze = '0'
        }

        if (res.ssl_switch.disable_merchant_set_ip_whitelist) {
          this.setForm.disable_merchant_set_ip_whitelist =
            res.ssl_switch.disable_merchant_set_ip_whitelist
        } else {
          this.setForm.disable_merchant_set_ip_whitelist = false
        }
      })
    } catch (e) {
      console.log()
    }
  }
  private antBankList: any = []
  private async init() {
    try {
      this.loading = true
      await AppModule.GetEnterprise().then((res: any) => {
        this.form = this.$store.state.app.enterprise
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private async PackagingSwitch(value: string) {
    try {
      let sslSwitch: any = {}
      sslSwitch[value] = this.setForm[value]
      const data = {
        ssl_switch: sslSwitch
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
      })
    } catch (e) {
      console.log()
    }
  }
  private packagingVisible: boolean = false
  private packagingValue: string = ''
  private packagingLabel: string = ''
  private openPackagingGroup(value: string, label: string) {
    this.packagingValue = value
    this.packagingVisible = true
    this.packagingLabel = label
    this.setForm.telegram_group = this.setForm[value]
  }

  private async tgSendMessage(value: any) {
    let str = value.split(';')[0]
    const data: any = {
      chat_id: str
    }
    await sendTelegramMessage(data).then(() => {
      this.$message({
        message: 'Send Successfully!',
        type: 'success'
      })
    })
  }
  private addLimitTg() {
    this.setForm.telegram_group.push('')
    this.setForm.group_name = ''
  }
  private removeLimitTg(index: number) {
    this.setForm.telegram_group.splice(index, 1)
  }
  private closeLimitTg() {
    this.setForm.group_name = ''
    this.setForm.telegram_group = this.setForm.telegram_group.filter(
      item => item !== ''
    )
    this.packagingVisible = false
  }
  private async addTgLimitGroup() {
    try {
      this.setForm.telegram_group = this.setForm.telegram_group.filter(
        item => item !== ''
      )
      this.flag = true
      let sslSwitch = {}
      sslSwitch[this.packagingValue] = this.setForm.telegram_group
      const data = {
        ssl_switch: sslSwitch
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        this.packagingVisible = false
        this.flagStr()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  private siteName: any = ''
  private systemName: any = 'Admin System'
  private sitelogo: any = ''
  private systemLogo: any = ''

  mounted() {
    this.init()
    this.getEnterprise()
    this.siteName = this.$store.state.app.enterprise.ssl_switch.site_name
    this.sitelogo = this.$store.state.app.enterprise.ssl_switch.site_logo
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.setting`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
